export default __webpack_public_path__ + "c99a6b9dce578e2f5999f3a1dc891f47.svg";